// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessAlert_root__E6L3F"};